import React, { Component, JSX, useCallback, useContext } from "react";
import { Blocker, useBeforeUnload, useBlocker } from "react-router-dom";
import { DirtyPageContext, IDirtyPageContext } from "./DirtyPageContext";

const defaultMessage =
    "You have unsaved changes. Are you sure you want to leave this page?";

export interface IDirtyPageGuardProps
{
    message?: string;
}

interface IDirtyPageGuardWithHooksProps extends IDirtyPageGuardProps
{
    blocker: Blocker;
}

export class DirtyPageGuard extends Component<IDirtyPageGuardWithHooksProps>
{
    public componentDidUpdate(): void
    {
        if (this.props.blocker.state !== "blocked")
        {
            return;
        }

        const shouldLeave = window.confirm(this.props.message ?? defaultMessage);
        if (shouldLeave)
        {
            this.props.blocker.proceed();
        }
else
{
            this.props.blocker.reset();
        }
    }

    public render(): null
    {
        return null;
    }
}

export function DirtyPageGuardBridge(props: IDirtyPageGuardProps): JSX.Element
{
    const context = useDirtyPageContext();
    const blocker = useBlocker(context.isAnyPageDirty);

    useBeforeUnload(
        useCallback(
            (event) =>
            {
                if (!context.isAnyPageDirty)
                {
                    return;
                }

                event.preventDefault();
                event.returnValue = "";
            },
            [context.isAnyPageDirty],
        ),
    );

    return <DirtyPageGuard {...props} blocker={blocker} />;
}

function useDirtyPageContext(): IDirtyPageContext
{
    const context = useContext(DirtyPageContext);
    if (!context)
    {
        throw new Error(
            "DirtyPageContext is not available. Wrap your app with DirtyPageProvider.",
        );
    }

    return context;
}

export default DirtyPageGuardBridge;
